import React from 'react';
import { useReclaim } from '../hooks/useReclaim';

const ReclaimTest = () => {
  const {
    isInitialized,
    isVerifying,
    isModalOpen,
    verificationError,
    verifiedData,
    isSupported,
    hasVerified,
    startVerification,
    resetError,
  } = useReclaim({
    providerId: 'example',
    onComplete: (data) => {
      console.log('Verification completed:', data);
    },
    onError: (error) => {
      console.error('Verification error:', error);
    },
  });

  if (!isSupported) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>Reclaim Not Supported</h2>
        <p>Please set REACT_APP_RECLAIM_PROVIDER_ID in your .env file</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h1>Reclaim Hook Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Status:</h3>
        <ul>
          <li>Initialized: {isInitialized ? '✅' : '❌'}</li>
          <li>Verifying: {isVerifying ? '🔄' : '⏸️'}</li>
          <li>Modal Open: {isModalOpen ? '📱' : '��'}</li>
          <li>Has Verified: {hasVerified ? '✅' : '❌'}</li>
        </ul>
      </div>

      {verificationError && (
        <div style={{ 
          padding: '15px', 
          backgroundColor: '#fee', 
          border: '1px solid #fcc', 
          borderRadius: '5px',
          marginBottom: '20px'
        }}>
          <h4>Error:</h4>
          <p>{verificationError}</p>
          <button onClick={resetError}>Clear Error</button>
        </div>
      )}

      {verifiedData && (
        <div style={{ 
          padding: '15px', 
          backgroundColor: '#efe', 
          border: '1px solid #cfc', 
          borderRadius: '5px',
          marginBottom: '20px'
        }}>
          <h4>Verified Data:</h4>
          <pre style={{ 
            backgroundColor: '#f5f5f5', 
            padding: '10px', 
            borderRadius: '3px',
            overflow: 'auto',
            maxHeight: '200px'
          }}>
            {JSON.stringify(verifiedData, null, 2)}
          </pre>
        </div>
      )}

      <div style={{ textAlign: 'center' }}>
        <button
          onClick={startVerification}
          disabled={!isInitialized}
          style={{
            padding: '15px 30px',
            fontSize: '16px',
            backgroundColor: isInitialized ? '#007bff' : '#ccc',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: isInitialized && !isVerifying ? 'pointer' : 'not-allowed'
          }}
        >
          {isVerifying ? 'Verifying...' : 'Start Verification'}
        </button>
      </div>

      {isVerifying && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <p>🔍 Verification in progress...</p>
          <p>Please follow the instructions on your device</p>
        </div>
      )}
    </div>
  );
};

export default ReclaimTest;